import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import { PatchBlock, ReadBlock } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PatchBlockParams {
  blockId: string;
  /**
   * The block's campaign, used for cache invalidation only: a block edit flips
   * the campaign's published pages to `needs_republication` server-side, and
   * the campaign query is where blocks and page outdated badges render from.
   */
  campaignId: string;
  data: PatchBlock;
}

export const patchBlock = async (
  params: PatchBlockParams,
): Promise<ReadBlock> => {
  return await tinctApi.blocks.patchBlock(params.blockId, params.data);
};

export const usePatchBlock = (
  options?: Omit<
    UseMutationOptions<ReadBlock, ApiError, PatchBlockParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchBlock,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].campaignId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
